import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { Label } from './Label';
import { CALENDLY_URL, LINKEDIN_URL } from '../data/site';
export function CtaBand() {
  return <section className="grain relative isolate w-full overflow-hidden bg-navy py-24 sm:py-32" data-id="element-61" data-mp="hg3xynlp1gdo">
      <div className="relative mx-auto max-w-[720px] px-5 sm:px-8" data-id="element-62" data-mp="mgi605naoqbp">
        <Reveal data-id="element-63" data-mp="rfbetkrmzt5j">
          <div className="flex items-center gap-3" data-id="element-64" data-mp="rfuralyippc6">
            <span className="h-px w-10 bg-copper" data-id="element-65" data-mp="rd8oezmkny0a" />
            <Label data-id="element-66" data-mp="vg4y20u4wjs3">Next step</Label>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-67" data-mp="107mz0ow5qkd2">
          <h2 className="mt-8 font-serif text-[2.6rem] italic leading-[1.02] text-cream sm:text-5xl" data-id="element-68" data-mp="107d9t3ixsh8f">
            Thirty minutes on your AI strategy.
            <span className="mt-2 block text-copper" data-id="element-69" data-mp="158ubv2d5q9ql">No slideware.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.12} data-id="element-70" data-mp="1a3zrjjfyus68">
          <p className="mt-8 font-sans text-base font-light leading-relaxed text-cream/70 sm:text-lg" data-id="element-71" data-mp="1f4e3vdolooa2">
            Bring one ambition and one constraint. You will leave with a clear view of the gap
            between them. Pick a slot directly, or reach me on LinkedIn.
          </p>
          <a href={CALENDLY_URL} target="_blank" rel="noreferrer noopener" className="mt-10 inline-flex items-center gap-3 bg-copper px-7 py-4 font-sans text-[11px] uppercase tracking-label text-navy transition-colors duration-200 ease-editorial hover:bg-copper-light" data-id="element-72" data-mp="1p8xk08np8vpx">
            Book on Calendly
            <ArrowUpRightIcon className="h-4 w-4" data-id="element-73" data-mp="2czjrnytskdze" />
          </a>
          <a href={LINKEDIN_URL} target="_blank" rel="noreferrer noopener" className="mt-6 block font-sans text-[11px] uppercase tracking-label text-cream/60 underline decoration-copper/50 underline-offset-8 hover:text-cream" data-id="element-74" data-mp="2879tjviiw7m1">
            LinkedIn
          </a>
        </Reveal>
      </div>
    </section>;
}